<h1 class="ir_pm tit_top">로고 이미지</h1>
<ul class="list_head">
  <li #menuProfile>
    <a class="ico_comm btn_login">login</a>
    <ul
      class="list_gnb"
      [style]="
        menuProfileState === 'opened'
          ? {
              display: 'block',
            }
          : {
              display: 'none',
            }
      "
    >
      @if (userIsAdmin$ | async) {
        <li>
          <a class="link_gnb link_admin" routerLink="/admin" [@animationProfile]="menuProfileState">
            <span class="txt_gnb">Accounts Admin</span></a
          >
        </li>
      }
      <li>
        <a
          class="link_gnb link_logout"
          [@animationProfile]="menuProfileState"
          [style]="
            menuProfileState === 'opened'
              ? {
                  display: 'block',
                }
              : {
                  display: 'none',
                }
          "
          (click)="onClickLogout($event)"
        >
          <span class="txt_gnb">Logout</span>
        </a>
      </li>
    </ul>
  </li>
  <li>
    <button type="button" class="ico_comm btn_corechat" (click)="onOpenCoreChat($event)">corechat</button>
  </li>
</ul>
